
import { Comment } from '../types/comment';

interface CommentBubbleProps {
  comment: Comment;
  formatTime: (dateString: string) => string;
}

const CommentBubble = ({ comment, formatTime }: CommentBubbleProps) => {
  // Use sentimentLabel first, fall back to status if no sentimentLabel is available
  const sentiment = comment.sentimentLabel || comment.status;
  
  const sentimentClass = 
    sentiment === 'positive' 
      ? 'bg-green-100 dark:bg-green-900/30 text-green-800 dark:text-green-200' 
      : sentiment === 'negative'
      ? 'bg-red-100 dark:bg-red-900/30 text-red-800 dark:text-red-200'
      : 'bg-gray-100 dark:bg-gray-700 text-gray-800 dark:text-gray-200';

  // Get sentiment label in French
  const getSentimentLabel = (sentiment: string) => {
    switch(sentiment) {
      case 'positive': return 'Positif';
      case 'negative': return 'Négatif';
      case 'neutral': return 'Neutre';
      default: return sentiment;
    }
  };

  return (
    <div className="mb-4">
      <div className="flex items-start space-x-3">
        <div className="h-10 w-10 rounded-full bg-gray-200 dark:bg-gray-700 flex items-center justify-center text-gray-600 dark:text-gray-300 text-sm font-medium">
          {comment.author.name.charAt(0) || 'U'}
        </div>
        
        <div className="flex-1">
          <div className="flex items-center">
            <h4 className="font-medium text-gray-900 dark:text-gray-100">{comment.author.name || 'Utilisateur inconnu'}</h4>
            <span className="ml-2 text-xs text-gray-500 dark:text-gray-400">{formatTime(comment.timestamp.toString())}</span>
            
            {/* Display sentiment prominently */}
            <span className={`ml-auto px-2 py-1 text-xs rounded-full ${sentimentClass}`}>
              {getSentimentLabel(sentiment)}
            </span>
          </div>
          
          <div className="mt-1 p-3 bg-gray-100 dark:bg-gray-800 rounded-lg text-gray-800 dark:text-gray-200">
            {comment.content}
          </div>
          
          <div className="mt-2 flex items-center space-x-4">
            <span className="text-sm text-gray-500 dark:text-gray-400">Likes: {comment.likes || 0}</span>
          </div>
        </div>
      </div>
    </div>
  );
};

export default CommentBubble;
